// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"55db7e15166810c65380","678":"cc4b588b7e900fb3ffd9","731":"03c6010771efa55a05e1","843":"97556456758776d9896e","883":"fc48d65eb5cc57762b66"}[chunkId] + ".js";
};